<script lang="ts" setup>
import { ref, computed } from 'vue';
</script>




<template>
    <div>
        <router-view />
    </div>
</template>